import { useState, useEffect } from "react";

const STORAGE_KEY = "dashboard-include-payg-stats";

export const usePaygStatsPreference = () => {
  const [includePaygInStats, setIncludePaygInStats] = useState<boolean>(() => {
    // Default to false (exclude PAYG) to maintain current behavior
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : false;
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(includePaygInStats));
  }, [includePaygInStats]);

  return {
    includePaygInStats,
    setIncludePaygInStats,
  };
};
